import { useQuery, type QueryKey } from '@tanstack/react-query';

type UseFetchOptions<TResponse, TData = TResponse> = {
  api: () => Promise<TResponse>;
  keywords: QueryKey;
  enabled?: boolean;
  staleTime?: number;
  refetchOnMount?: boolean | 'always';
  transform?: (data: TResponse) => TData;
};

export const useFetch = <TResponse, TData = TResponse>({
  api,
  keywords,
  enabled,
  staleTime,
  refetchOnMount,
  transform,
}: UseFetchOptions<TResponse, TData>) => {
  return useQuery<TData, Error>({
    queryKey: keywords,
    queryFn: async () => {
      const response = await api();
      return transform ? transform(response) : (response as unknown as TData);
    },
    enabled,
    staleTime: staleTime ?? 5 * 60 * 1000,
    refetchOnMount,
  });
};
